/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plant_Set_Tab_2Inputs */

const en_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Frequent Focus Sets`)
};

const ar_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حفظ مجموعات التركيز المتكررة`)
};

const de_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufige Fokus-Sets speichern`)
};

const es_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar ajustes de concentración frecuentes`)
};

const fr_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement de vos ensembles fréquents`)
};

const it_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio di set di concentrazione frequenti`)
};

const ja_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よく使うフォーカス設定を保存`)
};

const ko_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자주 쓰는 집중 세트 저장`)
};

const pt_br_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar conjuntos de foco frequentes`)
};

const ru_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранение частых наборов фокуса`)
};

const th_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกชุดการโฟกัสที่ใช้บ่อย`)
};

const tr_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sık Kullanılan Odak Setlerini Kaydet`)
};

const zh_cn_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`储存常用专注组合`)
};

const zh_tw_plant_set_tab_2 = /** @type {(inputs: Plant_Set_Tab_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存常用專注組合`)
};

/**
* | output |
* | --- |
* | "Save Frequent Focus Sets" |
*
* @param {Plant_Set_Tab_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plant_set_tab_2 = /** @type {((inputs?: Plant_Set_Tab_2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plant_Set_Tab_2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plant_set_tab_2(inputs)
	if (locale === "ar") return ar_plant_set_tab_2(inputs)
	if (locale === "de") return de_plant_set_tab_2(inputs)
	if (locale === "es") return es_plant_set_tab_2(inputs)
	if (locale === "fr") return fr_plant_set_tab_2(inputs)
	if (locale === "it") return it_plant_set_tab_2(inputs)
	if (locale === "ja") return ja_plant_set_tab_2(inputs)
	if (locale === "ko") return ko_plant_set_tab_2(inputs)
	if (locale === "pt_br") return pt_br_plant_set_tab_2(inputs)
	if (locale === "ru") return ru_plant_set_tab_2(inputs)
	if (locale === "th") return th_plant_set_tab_2(inputs)
	if (locale === "tr") return tr_plant_set_tab_2(inputs)
	if (locale === "zh_cn") return zh_cn_plant_set_tab_2(inputs)
	return zh_tw_plant_set_tab_2(inputs)
});